module.exports = __webpack_public_path__ + "static/media/office.b2c8d9c6.jpg";